<template>
  <LayoutOneColumn :loading="loading">
    <div>
      <TopbarMenu :menu-list="topbarMenu" />
      <NuxtPage />
    </div>
  </LayoutOneColumn>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import type { ComputedRef } from 'vue'
import { useNavigation } from '~/stores/navigation'
import type { TopbarMenuInterface } from '~/models/menu'
import { NavigationSortType } from '~/models/navigation'

const { t } = useI18n()
const { getSortItems, getCategoryItems, fetchCategories } = useNavigation()
const navStore = useNavigation()
const loading = ref(!navStore.categoriesList.length)

onBeforeMount(async () => {
  await fetchCategories()
  loading.value = false
})

onServerPrefetch(async () => {
  await fetchCategories()
  loading.value = false
})

const sorts = getSortItems('questions', [
  NavigationSortType.Popular,
  NavigationSortType.All,
])

const categories = getCategoryItems('questions')

const topbarMenu: ComputedRef<TopbarMenuInterface[]> = computed(() => [
  {
    title: t('menu.all_questions'),
    items: sorts.value,
    style: 'col',
  },
  {
    title: t('common.categories'),
    items: categories.value,
    style: 'row',
  },
])
</script>
